/**
 * Created by Bart Decorte
 * Date: 2019-09-10
 * Time: 22:29
 */
import Page from '../pages/Page';
import Request from '../utils/Request';

export default class QuestionsShow extends Page {
  constructor() {
    super();
    this.bindListeners();
  }

  bindListeners() {
    $('.js-feedback-control').on('click', (ev) =>
      this.lButtonFeedbackClicked(ev)
    );
    $('.js-feedback-form-submit').on('click', (ev) =>
      this.lButtonInputSubmitClicked(ev)
    );
    $('.js-feedback-form-input').on('input', (ev) =>
      this.lFeedbackFormInput(ev)
    );
  }

  lButtonFeedbackClicked(ev) {
    const $elt = $(ev.target).is('.js-feedback-control')
      ? $(ev.target)
      : $(ev.target)
          .parents('.js-feedback-control')
          .first();
    const type = $elt.data('feedback-type');
    this.propagateLike($elt.val())
      .then(() => this.setLikeControlActive(type, true))
      .then(() => this.showFeedbackForm(type == 'negative'));
  }

  lButtonInputSubmitClicked(ev) {
    const $elt = $('.js-feedback-form-input');
    if ($elt.is('[disabled]')) {
      return this;
    }
    const feedback = $elt.val();
    this.propagateFeedback(feedback)
      .then(
        () => this.showFeedbackSuccess(),
        () => this.showFeedbackFail()
      )
      .then(() => this.showFeedbackQuestion(false))
      .then(() => this.showFeedbackForm(false))
      .then(() => this.showLikeControls(false));

    return this;
  }

  lFeedbackFormInput(ev) {
    const val = $('.js-feedback-form-input').val();
    this.setSubmitControlActive(val.length > 0);
  }

  questionId() {
    return $('.js-question').data('question-id');
  }

  propagateLike(weight = 1) {
    const data = {
      was_helpful: weight,
    };

    const endpoint = ['questions', this.questionId(), 'responses'].join('/');
    const request = new Request(endpoint, 'post', data);
    return request.execute();
  }

  propagateFeedback(feedback) {
    const data = { feedback };

    const endpoint = ['questions', this.questionId(), 'responses'].join('/');
    const request = new Request(endpoint, 'put', data);
    return request.execute();
  }

  // wich is one of 'positive', 'negative'
  setLikeControlActive(which, doSetActive = true) {
    const $active = $('.js-feedback-control.active');
    $active.removeClass('active');
    const $control = $(`.js-feedback-control--${which}`);
    $control.addClass('active');
    return this;
  }

  setSubmitControlActive(doSetActive = true) {
    const $elt = $('.js-feedback-form-submit');
    $elt.prop('disabled', !doSetActive);
    return this;
  }

  showFeedbackQuestion(doShow = true) {
    const $elt = $('.js-feedback-question');
    if (doShow) {
      $elt.removeAttr('style');
      return this;
    }
    $elt.css('display', 'none');
    return this;
  }

  showLikeControls(doShow = true) {
    const $elt = $('.js-feedback-controls');
    if (doShow) {
      $elt.removeAttr('style');
      return this;
    }
    $elt.css('display', 'none');
    return this;
  }

  showFeedbackForm(doShow = true) {
    const $elt = $('.js-feedback-form');
    if (doShow) {
      $elt.removeAttr('style');
      return this;
    }
    $elt.css('display', 'none');
    return this;
  }

  showFeedbackSuccess(doShow = true) {
    const $elt = $('.js-feedback-response--success');
    if (doShow) {
      $elt.removeAttr('style');
      return this;
    }
    $elt.css('display', 'none');
    return this;
  }

  showFeedbackFail(doShow = true) {
    const $elt = $('.js-feedback-response--fail');
    if (doShow) {
      $elt.removeAttr('style');
      return this;
    }
    $elt.css('display', 'none');
    return this;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/content/QuestionsShow.js